export default __webpack_public_path__ + "static/media/Bracers of the Bloodmoon.b58f8380.jpg";